import React, { useState, useEffect, useRef } from "react";

import { Ripple } from "primereact/ripple";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { Nullable } from "primereact/ts-helpers";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { InputNumberChangeEvent } from "primereact/inputnumber";
import { Checkbox, CheckboxChangeEvent } from "primereact/checkbox";

import { goToTop } from "../../../Components/goToTop";
import { formatDate, parseStringToDate } from "../../../Utils/getDate";
import DatePicker from "../../../Components/DatePicker";
import Textarea from "../../../Components/TextArea";
import TextInput from "../../../Components/TextInput";
import NumberInput from "../../../Components/NumberInput";
import { baseURL } from "../../../Api/ApiConstant";

import { ToolType } from "../../../Controllers/Types/HeyTraderTypes/Tools/ToolType";
import { ToolCategoryList } from "../../../Controllers/Types/HeyTraderTypes/Tools/ToolCategoryList";
import { BrandList } from "../../../Controllers/Types/HeyTraderTypes/Tools/BrandList";
import { StorageList } from "../../../Controllers/Types/HeyTraderTypes/Tools/StorageList";
import { ToolList } from "../../../Controllers/Types/HeyTraderTypes/Tools/ToolList";
import { useAppDispatch, useAppSelector } from "../../../Controllers/hooks";
import {
  getCommonProjects,
  getToolBrandList,
  getToolCategoryList,
  getToolList,
  getToolStorageList,
} from "../../../Controllers/Thunks/HeyTraderThunks";
import { CommonProjectType } from "../../../Controllers/Types/HeyTraderTypes/CommonProjectType";
import {
  addToolBrand,
  addTools,
  addToolStorage,
  updateTools,
} from "../../../Api/HeyTraderService/ToolsService";
import {
  checkModelSelected,
  checkNumber,
  checkText,
} from "../../../Utils/Validator";

interface ToolModalProps {
  isOpen?: boolean;
  dataState?: "Add" | "Edit";
  onClose: () => void;
  onSuccess: (message: string) => void;
  toast: React.RefObject<Toast>;
  toolData?: ToolList | null;
  mainProject?: CommonProjectType | null
}

const ToolModal: React.FC<ToolModalProps> = ({
  isOpen,
  dataState,
  onClose,
  onSuccess,
  toast,
  toolData,
  mainProject
}) => {
  const today = new Date();

  const [loading, setLoading] = useState<boolean>(false);
  const [customCreateLoading, setCustomCreateLoading] =
    useState<boolean>(false);

  /* Tool fields */
  const [toolDetails, setToolDetails] = useState<ToolList | null>(null);
  const [toolAddState, setToolAddState] = useState<"On Site" | "Storage">(
    "On Site"
  );
  const [toolCode, setToolCode] = useState<string>("");
  const [quantity, setQuantity] = useState<number>(1);
  const [note, setNote] = useState<string>("");

  /* Tool Error fields */
  const [siteError, setSiteError] = useState<string>("");
  const [storageError, setStorageError] = useState<string>("");
  const [brandError, setBrandError] = useState<string>("");
  const [categoryError, setCategoryError] = useState<string>("");
  const [toolCodeError, setToolCodeError] = useState<string>("");
  const [quantityError, setQuantityError] = useState<string>("");
  const [noteError, setNoteError] = useState<string>("");

  /* Site */
  const [sitesData, setSitesData] = useState<CommonProjectType[]>([]);
  const [filteredSitesData, setFilteredSitesData] = useState<
    CommonProjectType[]
  >([]);
  const [selectedSiteData, setSelectedSiteData] =
    useState<CommonProjectType | null>(null);
  const [showSiteModal, setShowSiteModal] = useState<boolean>(false);
  const [siteSearchKey, setSiteSearchKey] = useState<string>("");

  /* Storage */
  const [storagesData, setStoragesData] = useState<StorageList[]>([]);
  const [filteredStoragesData, setFilteredStoragesData] = useState<
    StorageList[]
  >([]);
  const [selectedStorageData, setSelectedStorageData] =
    useState<StorageList | null>(null);
  const [showStorageModal, setShowStorageModal] = useState<boolean>(false);
  const [storageSearchKey, setStorageSearchKey] = useState<string>("");
  const [customStorageAddress, setCustomStorageAddress] = useState<string>("");
  const [customStorageAddressError, setCustomStorageAddressError] =
    useState<string>("");

  /* Brand */
  const [brandsData, setBrandsData] = useState<BrandList[]>([]);
  const [filteredBrandsData, setFilteredBrandsData] = useState<BrandList[]>([]);
  const [selectedBrandData, setSelectedBrandData] = useState<BrandList | null>(
    null
  );
  const [showBrandModal, setShowBrandModal] = useState<boolean>(false);
  const [brandSearchKey, setBrandSearchKey] = useState<string>("");
  const [customBrandName, setCustomBrandName] = useState<string>("");
  const [customBrandNameError, setCustomBrandNameError] = useState<string>("");

  /* Category/tool type */
  const [toolCategoriesData, setToolCategoriesData] = useState<
    ToolCategoryList[]
  >([]);
  const [filteredToolCategoriesData, setFilteredToolCategoriesData] = useState<
    ToolCategoryList[]
  >([]);
  const [selectedToolCategoryData, setSelectedToolCategoryData] =
    useState<ToolCategoryList | null>(null);
  const [selectedToolTypeData, setSelectedToolTypeData] =
    useState<ToolType | null>(null);
  const [showCategoryModal, setShowCategoryModal] = useState<boolean>(false);
  const [categorySearchKey, setCategorySearchKey] = useState<string>("");
  const [expandedCategoryId, setExpandedCategoryId] = useState<number | null>(
    null
  );

  /* Warranty */
  const warrantyDetailRef = useRef<HTMLDivElement | null>(null);
  const [isHaveWarranty, setIsHaveWarranty] = useState<boolean>(false);
  const [isWarrantyApplied, setIsWarrantyApplied] = useState<boolean>(false);
  const [showWarrantyModal, setShowWarrantyModal] = useState<boolean>(false);
  const [purchaseDate, setPurchaseDate] = useState<Nullable<Date>>(null);
  const [months, setMonths] = useState<number | null>(null);
  const [purchaseDateError, setPurchaseDateError] = useState<string>("");
  const [monthError, setMonthError] = useState<string>("");

  // database api collection data ass well

  useEffect(() => {
    if (toolData && toolData != null) {
      setToolDetails(toolData);
      if (mainProject && mainProject !== null) {
        setSelectedSiteData(mainProject!);
      }

    }
  }, [toolData]);


  useEffect(() => {
    setSelectedSiteData(mainProject!);
  }, [mainProject]);

  // for the resons
  const dispatch = useAppDispatch();

  // this is get data from state list and set projectlist
  const toolListData = useAppSelector((state) => state.toolsList.toolList);

  const toolCategoryLists = useAppSelector(
    (state) => state.toolCategories.toolCategories
  );

  const brandLists = useAppSelector((state) => state.toolBraands.toolBrands);

  const storageLists = useAppSelector(
    (state) => state.toolStorages.toolStorages
  );

  const projectList = useAppSelector(
    (state) => state.commonProjectList.projectList
  );

  // for fetching data fro api tigger with state object actions
  useEffect(() => {
    dispatch(getToolList());
    dispatch(getToolCategoryList());
    dispatch(getToolBrandList());
    dispatch(getToolStorageList());
    dispatch(getCommonProjects());
  }, []);

  // set brands
  useEffect(() => {
    const filteredBrands = brandLists?.filter((brand) => brand?.status === 1);
    if (filteredBrands && filteredBrands.length > 0) {
      setBrandsData(filteredBrands);
    } else {
      setBrandsData([]);
    }
  }, [brandLists]);

  //   set categories
  useEffect(() => {
    const filteredToolCategories = toolCategoryLists?.filter(
      (category) => category?.status === 1
    );
    if (filteredToolCategories && filteredToolCategories.length > 0) {
      setToolCategoriesData(filteredToolCategories);
    } else {
      setToolCategoriesData([]);
    }
  }, [toolCategoryLists]);

  //   set tool storages
  useEffect(() => {
    const filteredStorages = storageLists?.filter(
      (storage) => storage?.status === 1
    );
    if (filteredStorages && filteredStorages.length > 0) {
      setStoragesData(filteredStorages);
    } else {
      setStoragesData([]);
    }
  }, [storageLists]);

  // project lists
  useEffect(() => {
    const filteredStorages = storageLists?.filter(
      (storage) => storage?.status === 1
    );
    if (filteredStorages && filteredStorages.length > 0) {
      setStoragesData(filteredStorages);
    } else {
      setStoragesData([]);
    }
  }, [storageLists]);

  //   set project list
  useEffect(() => {
    if (projectList && projectList.length > 0) {
      setSitesData(projectList);
    }
  }, [projectList]);

  useEffect(() => {
    if (dataState === "Edit" && toolDetails && toolDetails !== null) {
      const existSiteData = sitesData.find(
        (site) => site?.project_id === toolDetails?.project_id
      );
      const existStorageData = storagesData?.find(
        (storage) => storage?.id === toolDetails?.storage_id
      );
      const existBrandData = brandsData?.find(
        (brand) => brand?.id === toolDetails?.brand_id
      );
      const existToolCategoryData = toolCategoriesData?.find(
        (category) => category?.id === toolDetails?.category_id
      );
      const existToolTypeData = existToolCategoryData?.tool_type?.find(
        (type) => type?.id === toolDetails?.type_id
      );

      setToolAddState(toolDetails?.keep_in);

      if (toolDetails?.keep_in === "On Site") {
        setSelectedSiteData(existSiteData || null);
      } else if (toolDetails?.keep_in === "Storage") {
        setSelectedStorageData(existStorageData || null);
      } else {
        setSelectedSiteData(null);
        setSelectedStorageData(null);
      }

      setSelectedBrandData(existBrandData || null);
      setExpandedCategoryId(existToolCategoryData?.id || null);
      setSelectedToolCategoryData(existToolCategoryData || null);
      setSelectedToolTypeData(existToolTypeData || null);
      setToolCode(toolDetails?.tool_name || "");
      setQuantity(toolDetails?.tool_count || 1);
      setNote(toolDetails?.note || "");
    }
  }, [
    isOpen,
    dataState,
    toolDetails,
    sitesData,
    storagesData,
    brandsData,
    toolCategoriesData,
  ]);

  /* *********************************** Tool ********************************** */
  const handleCloseToolModal = () => {
    onClose();
    handleClearToolFields();
    handleClearToolErrors();
  };

  const handleClearToolFields = () => {
    if (mainProject && mainProject === null) {
      setSelectedSiteData(null);
    }
    setSelectedStorageData(null);
    setSelectedBrandData(null);
    setSelectedToolCategoryData(null);
    setSelectedToolTypeData(null);
    setExpandedCategoryId(null);
    setToolCode("");
    setQuantity(1);
    setNote("");

    setIsHaveWarranty(false);
    setPurchaseDate(null);
    setMonths(null);
  };

  const handleClearToolErrors = () => {
    setSiteError("");
    setStorageError("");
    setBrandError("");
    setCategoryError("");
    setToolCodeError("");
    setQuantityError("");
    setNoteError("");
    setPurchaseDateError("");
    setMonthError("");
  };

  //   common validation for checking
  function checkCredentials(): boolean {
    const brand = checkModelSelected(
      selectedBrandData != null,
      true,
      setBrandError
    );
    const category = checkModelSelected(
      selectedToolCategoryData != null,
      true,
      setCategoryError
    );
    const tool_code = checkText(toolCode!, true, setToolCodeError);
    const qty = checkNumber(quantity!, true, setQuantityError);

    if (toolAddState === "On Site") {
      const site = checkModelSelected(
        selectedSiteData != null,
        true,
        setSiteError
      );
      return brand && category && site && tool_code && qty;
    } else {
      const storage = checkModelSelected(
        selectedStorageData != null,
        true,
        setStorageError
      );
      return brand && category && storage && tool_code && qty;
    }
  }

  //   tool create functions.
  const handleCreateTool = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);

      const data = await addTools(
        toolAddState,
        selectedSiteData?.project_id!,
        selectedStorageData?.id!,
        selectedToolCategoryData?.id!,
        selectedToolTypeData?.id!,
        selectedBrandData?.id!,
        toolCode,
        note,
        quantity,
        isHaveWarranty ? 1 : 0,
        formatDate(purchaseDate!),
        months!
      );

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getToolList());

        handleClearToolErrors();
        handleClearToolFields();
        setLoading(false);
        onSuccess("Tool created successfully.");
        onClose();
        goToTop();
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Error creating tool.",
            detail: "There was an error creating tool.",
            life: 3000,
          });
        }
      }
    }
  };

  //   tool update functions.
  const handleUpdateTool = async (e: React.FormEvent) => {
    e.preventDefault();

    if (checkCredentials()) {
      setLoading(true);

      const data = await updateTools(
        toolAddState,
        selectedSiteData?.project_id!,
        selectedStorageData?.id!,
        selectedToolCategoryData?.id!,
        selectedToolTypeData?.id!,
        selectedBrandData?.id!,
        toolCode,
        note,
        quantity,
        toolDetails?.tool_id!
      );

      if (data.statusCode === 200) {
        // call dispach event
        dispatch(getToolList());

        handleClearToolErrors();
        handleClearToolFields();
        setLoading(false);
        onSuccess("Tool updated successfully.");
        onClose();
        goToTop();
      } else {
        setLoading(false);
        if (toast.current) {
          toast.current.show({
            severity: "error",
            summary: "Error creating tool.",
            detail: "There was an error updating tool.",
            life: 3000,
          });
        }
      }
    }
  };

  const handleValidateToolForm = () => {
    return (
      (toolAddState === "On Site" && selectedSiteData === null) ||
      (toolAddState === "Storage" && selectedStorageData === null) ||
      selectedBrandData === null ||
      selectedToolCategoryData === null ||
      selectedToolTypeData === null ||
      toolCode === "" ||
      quantity === null ||
      (isHaveWarranty && (purchaseDate === null || months === null))
    );
  };

  const toolModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">{dataState} tool {(mainProject && mainProject !== null) && `(${mainProject.address})`}</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseToolModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const toolModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Close"
        className="custom_btn secondary"
        onClick={handleCloseToolModal}
      />

      <Button
        label={`${loading ? "Processing" : dataState === "Add" ? "Submit" : "Update"
          }`}
        onClick={dataState === "Add" ? handleCreateTool : handleUpdateTool}
        loading={loading}
        disabled={handleValidateToolForm()}
        className="custom_btn primary"
      />
    </div>
  );

  const handleSwitchToolAddState = (state: "On Site" | "Storage") => {
    setToolAddState(state);
  };

  const handleQuantityChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setQuantity(e.value);
    }
  };
  /* *************************************************************************** */

  /* *********************************** Site ********************************** */
  useEffect(() => {
    if (sitesData && sitesData?.length > 0) {
      const filteredSites = sitesData.filter(
        (site) =>
          site
            ?.job_number!.toLowerCase()
            .includes(siteSearchKey.toLowerCase()) ||
          site?.address!.toLowerCase().includes(siteSearchKey.toLowerCase())
      );
      setFilteredSitesData(filteredSites);
    } else {
      setFilteredSitesData([]);
    }
  }, [sitesData, siteSearchKey]);

  const handleCloseSiteModal = () => {
    setShowSiteModal(false);
    setSiteSearchKey("");
  };

  const handleAddSite = () => {
    setShowSiteModal(true);
  };

  const handleSelectSite = (site: CommonProjectType) => {
    setSelectedSiteData(site);

    setTimeout(() => {
      handleCloseSiteModal();
    }, 200);
  };
  /* *************************************************************************** */

  /* ********************************* Storage ********************************* */
  useEffect(() => {
    if (storagesData && storagesData?.length > 0) {
      const filteredStorages = storagesData.filter((storage) =>
        storage
          ?.storage_name!.toLowerCase()
          .includes(storageSearchKey.toLowerCase())
      );
      setFilteredStoragesData(filteredStorages);
    } else {
      setFilteredStoragesData([]);
    }
  }, [storagesData, storageSearchKey]);

  const handleCloseStorageModal = () => {
    setShowStorageModal(false);
    setStorageSearchKey("");

    handleClearCustomStorageFields();
  };

  const handleClearCustomStorageFields = () => {
    setCustomStorageAddress("");
    setCustomStorageAddressError("");
  };

  const handleAddStorage = () => {
    setShowStorageModal(true);
  };

  const handleSelectStorage = (storage: StorageList) => {
    setSelectedStorageData(storage);

    setTimeout(() => {
      handleCloseStorageModal();
    }, 200);
  };

  //   to add custom storage name ass well.
  const handleCreateCustomStorage = async (e: React.FormEvent) => {
    e.preventDefault();

    setCustomCreateLoading(true);
    const data = await addToolStorage(customStorageAddress);

    if (data.statusCode === 200) {
      // call shop dispach event
      dispatch(getToolStorageList());

      setCustomCreateLoading(false);
      handleClearCustomStorageFields();
      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Storage created successfully.",
          life: 3000,
        });
      }
    } else {
      setCustomCreateLoading(false);
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error creating the storage.",
          life: 3000,
        });
      }
    }
  };
  /* *************************************************************************** */

  /* ********************************** Brand ********************************** */
  useEffect(() => {
    if (brandsData && brandsData?.length > 0) {
      const filteredBrands = brandsData.filter((brand) =>
        brand?.brand_name!.toLowerCase().includes(brandSearchKey.toLowerCase())
      );
      setFilteredBrandsData(filteredBrands);
    } else {
      setFilteredBrandsData([]);
    }
  }, [brandsData, brandSearchKey]);

  const handleCloseBrandModal = () => {
    setShowBrandModal(false);
    setBrandSearchKey("");

    handleClearCustomBrandFields();
  };

  const handleClearCustomBrandFields = () => {
    setCustomBrandName("");
    setCustomBrandNameError("");
  };

  const handleAddBrand = () => {
    setShowBrandModal(true);
  };

  const handleSelectBrand = (brand: BrandList) => {
    setSelectedBrandData(brand);

    setTimeout(() => {
      handleCloseBrandModal();
    }, 200);
  };

  const handleCreateCustomBrand = async (e: React.FormEvent) => {
    e.preventDefault();

    setCustomCreateLoading(true);
    const data = await addToolBrand(customBrandName);

    if (data.statusCode === 200) {
      // call dispach event
      dispatch(getToolBrandList());

      setCustomCreateLoading(false);
      handleClearCustomBrandFields();

      if (toast.current) {
        toast.current.show({
          severity: "success",
          summary: "Success",
          detail: "Brand created successfully.",
          life: 3000,
        });
      }
    } else {
      setCustomCreateLoading(false);
      if (toast.current) {
        toast.current.show({
          severity: "error",
          summary: "Failed",
          detail: "There was an error creating the brand.",
          life: 3000,
        });
      }
    }
  };
  /* *************************************************************************** */

  /* ******************************** Category ********************************* */
  useEffect(() => {
    if (toolCategoriesData && toolCategoriesData?.length > 0) {
      const filteredCategories = toolCategoriesData.filter((category) =>
        category
          ?.category_name!.toLowerCase()
          .includes(categorySearchKey.toLowerCase())
      );
      setFilteredToolCategoriesData(filteredCategories);
    } else {
      setFilteredToolCategoriesData([]);
    }
  }, [toolCategoriesData, categorySearchKey]);

  const handleCloseCategoryModal = () => {
    setShowCategoryModal(false);
    setCategorySearchKey("");
  };

  const handleAddCategory = () => {
    setShowCategoryModal(true);
  };

  const handleSelectCategory = (category: ToolCategoryList) => {
    setSelectedToolCategoryData(category);

    if (category?.tool_type && category?.tool_type?.length > 0) {
      setExpandedCategoryId(
        expandedCategoryId === category.id ? null : category.id!
      );
    } else {
      setExpandedCategoryId(null);
    }
  };

  const handleSelectToolType = (toolType: ToolType) => {
    setSelectedToolTypeData(toolType);

    setTimeout(() => {
      handleCloseCategoryModal();
    }, 200);
  };
  /* *************************************************************************** */

  /* ******************************** Warranty ********************************* */
  const handleChangeHaveWarranty = (e: CheckboxChangeEvent) => {
    setIsHaveWarranty(e.checked || false);

    if (e.checked) {
      handleOpenWarrantyModal();
    } else {
      handleClearWarrantyFields();
      handleClearWarrantyErrors();
      setIsWarrantyApplied(false);
    }
  };

  const handleClearWarrantyFields = () => {
    setPurchaseDate(null);
    setMonths(null);
  };

  const handleClearWarrantyErrors = () => {
    setPurchaseDateError("");
    setMonthError("");
  };

  const handleCloseWarrantyModal = () => {
    setShowWarrantyModal(false);
    handleClearWarrantyErrors();
    handleClearWarrantyFields();
    setIsHaveWarranty(false);
  };

  const handleOpenWarrantyModal = () => {
    setShowWarrantyModal(true);
  };

  const handleAddWarrantyDetail = (e: React.FormEvent) => {
    e.preventDefault();

    setIsWarrantyApplied(true);
    setShowWarrantyModal(false);

    setTimeout(() => {
      warrantyDetailRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 300);
  };

  const warrantyModalHeader = (
    <div className="custom_modal_header_inner">
      <h5 className="modal-title fs-5">Warranty details</h5>
      <button
        type="button"
        className="close_modal_btn p-ripple"
        onClick={handleCloseWarrantyModal}
      >
        <i className="bi bi-x-circle"></i>
        <Ripple />
      </button>
    </div>
  );

  const warrantyModalFooter = (
    <div className="custom_modal_footer">
      <Button
        label="Cancel"
        className="custom_btn secondary"
        onClick={handleCloseWarrantyModal}
      />

      <Button
        label="Confirm"
        onClick={handleAddWarrantyDetail}
        loading={loading}
        className="custom_btn primary"
        disabled={purchaseDate === null || months === null}
      />
    </div>
  );

  const handleWarrantyMonthChange = (e: InputNumberChangeEvent) => {
    if (e.value != null) {
      setMonths(e.value);
    }
  };
  /* *************************************************************************** */

  return (
    <React.Fragment>
      {/* Tool modal */}
      <Dialog
        visible={isOpen}
        headerClassName="custom_modal_header"
        header={toolModalHeader}
        footer={toolModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={() => {
          onClose();
          handleClearToolFields();
          handleClearToolErrors();
        }}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {(mainProject === null) && (
                <div className="col-12">
                  <div className="add_data_switch_btn_area">
                    <button
                      className={`add_data_switch_btn p-ripple ${toolAddState === "On Site" && "active"
                        }`}
                      type="button"
                      role="tab"
                      onClick={() => handleSwitchToolAddState("On Site")}
                    >
                      On Site
                      <Ripple />
                    </button>

                    <button
                      className={`add_data_switch_btn p-ripple ${toolAddState === "Storage" && "active"
                        }`}
                      type="button"
                      role="tab"
                      onClick={() => handleSwitchToolAddState("Storage")}
                    >
                      Storage
                      <Ripple />
                    </button>
                  </div>
                </div>
              )}

              {toolAddState === "On Site" ? (
                <React.Fragment>
                  {/* Site */}

                  {(mainProject === null) && (<div className="col-12">
                    <div className="page_form_group">
                      <label
                        htmlFor="site"
                        className="custom_form_label is_required"
                      >
                        Site
                      </label>
                      <div className="input_with_button_area">
                        <InputText
                          key={"site"}
                          id="site"
                          value={
                            selectedSiteData &&
                            selectedSiteData?.job_number +
                            " - " +
                            selectedSiteData?.address
                          }
                          className="custom_form_input has_add_value"
                          placeholder="Click to select the site."
                          readOnly={true}
                          autoComplete="off"
                          onClick={handleAddSite}
                        />
                        <button
                          className="add_value_btn p-ripple"
                          onClick={handleAddSite}
                        >
                          {selectedSiteData === null ? (
                            <React.Fragment>
                              <i className="bi bi-plus-lg"></i>
                              <span>Add</span>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <i className="bi bi-pencil-square"></i>
                              <span>Change</span>
                            </React.Fragment>
                          )}
                          <Ripple />
                        </button>
                      </div>

                      {siteError && (
                        <small className="form_error_msg">{siteError}</small>
                      )}
                    </div>
                  </div>)}


                </React.Fragment>
              ) : toolAddState === "Storage" ? (
                <React.Fragment>
                  {/* Storage */}
                  {(mainProject === null) && (<div className="col-12">
                    <div className="page_form_group">
                      <label
                        htmlFor="storage"
                        className="custom_form_label is_required"
                      >
                        Storage
                      </label>
                      <div className="input_with_button_area">
                        <InputText
                          key={"storage"}
                          id="storage"
                          value={
                            selectedStorageData &&
                            selectedStorageData?.storage_name
                          }
                          className="custom_form_input has_add_value"
                          placeholder="Click to select the storage."
                          readOnly={true}
                          autoComplete="off"
                          onClick={handleAddStorage}
                        />
                        <button
                          className="add_value_btn p-ripple"
                          onClick={handleAddStorage}
                        >
                          {selectedStorageData === null ? (
                            <React.Fragment>
                              <i className="bi bi-plus-lg"></i>
                              <span>Add</span>
                            </React.Fragment>
                          ) : (
                            <React.Fragment>
                              <i className="bi bi-pencil-square"></i>
                              <span>Change</span>
                            </React.Fragment>
                          )}
                          <Ripple />
                        </button>
                      </div>

                      {storageError && (
                        <small className="form_error_msg">{storageError}</small>
                      )}
                    </div>
                  </div>)}

                </React.Fragment>
              ) : null}

              {/* Brand */}
              <div className="col-12">
                <div className="page_form_group">
                  <label
                    htmlFor="brand"
                    className="custom_form_label is_required"
                  >
                    Brand
                  </label>
                  <div className="input_with_button_area">
                    <InputText
                      id="brand"
                      value={selectedBrandData && selectedBrandData?.brand_name}
                      className="custom_form_input has_add_value"
                      placeholder="Click to select the brand."
                      readOnly={true}
                      autoComplete="off"
                      onClick={handleAddBrand}
                    />
                    <button
                      className="add_value_btn p-ripple"
                      onClick={handleAddBrand}
                    >
                      {selectedBrandData === null ? (
                        <React.Fragment>
                          <i className="bi bi-plus-lg"></i>
                          <span>Add</span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <i className="bi bi-pencil-square"></i>
                          <span>Change</span>
                        </React.Fragment>
                      )}
                      <Ripple />
                    </button>
                  </div>

                  {brandError && (
                    <small className="form_error_msg">{brandError}</small>
                  )}
                </div>
              </div>

              {/* Category/Tool type */}
              <div className="col-12">
                <div className="page_form_group">
                  <label
                    htmlFor="category"
                    className="custom_form_label is_required"
                  >
                    Category
                  </label>
                  <div className="input_with_button_area">
                    <InputText
                      id="category"
                      value={
                        selectedToolTypeData &&
                        selectedToolCategoryData &&
                        selectedToolCategoryData?.category_name +
                        ` (${selectedToolTypeData?.type_name})`
                      }
                      className="custom_form_input has_add_value"
                      placeholder="Click to select the category and tool type."
                      readOnly={true}
                      autoComplete="off"
                      onClick={handleAddCategory}
                    />
                    <button
                      className="add_value_btn p-ripple"
                      onClick={handleAddCategory}
                    >
                      {selectedToolTypeData === null ? (
                        <React.Fragment>
                          <i className="bi bi-plus-lg"></i>
                          <span>Add</span>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <i className="bi bi-pencil-square"></i>
                          <span>Change</span>
                        </React.Fragment>
                      )}
                      <Ripple />
                    </button>
                  </div>

                  {categoryError && (
                    <small className="form_error_msg">{categoryError}</small>
                  )}
                </div>
              </div>

              {/* Tool code */}
              <div className="col-12">
                <TextInput
                  id="toolCode"
                  label="Tool code"
                  labelHtmlFor="toolCode"
                  required={true}
                  value={toolCode}
                  placeholder="Enter tool code"
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setToolCode(e.target.value)
                  }
                  error={toolCodeError}
                />
              </div>

              {/* Quantity */}
              <div className="col-12">
                <NumberInput
                  inputId="quantity"
                  label="Quantity"
                  labelHtmlFor="quantity"
                  placeholder="Enter quantity"
                  onChange={handleQuantityChange}
                  value={quantity}
                  required={true}
                  minFractionDigits={2}
                  maxFractionDigits={2}
                  min={1}
                  error={quantityError}
                />
              </div>

              {/* Note */}
              <div className="col-12">
                <Textarea
                  id="note"
                  label="Note"
                  labelHtmlFor="note"
                  required={false}
                  value={note}
                  placeholder="Note"
                  onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
                    setNote(e.target.value)
                  }
                  error={noteError}
                  formGroupClassName={dataState === "Edit" ? " mb-1" : ""}
                />
              </div>

              {/* Warranty */}
              {dataState === "Add" && (
                <div className="col-12">
                  <div className="page_form_group mb-0">
                    <div className="custom_form_check_group">
                      <Checkbox
                        inputId={`isHaveWarranty`}
                        onChange={handleChangeHaveWarranty}
                        checked={isHaveWarranty}
                      ></Checkbox>
                      <label
                        htmlFor={`isHaveWarranty`}
                        className={`custom_form_check_label`}
                      >
                        Have warranty
                      </label>
                    </div>
                  </div>
                </div>
              )}

              {isHaveWarranty &&
                purchaseDate !== null &&
                months !== null &&
                isWarrantyApplied && (
                  <div className="col-12" ref={warrantyDetailRef}>
                    <div className="warrenty_detail">
                      <h5>
                        <i className="bi bi-shield-check me-2"></i>
                        Warranty detail
                      </h5>
                      <div className="warrenty_detail_sub">
                        <h6>
                          Purchase date:{" "}
                          <span>{formatDate(purchaseDate!)}</span>
                        </h6>
                        <span className="divide_ln">|</span>
                        <h6>
                          Valid month(s):{" "}
                          <span>{String(months).padStart(2, "0")}</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                )}
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Warranty modal */}
      <Dialog
        visible={showWarrantyModal}
        headerClassName="custom_modal_header"
        header={warrantyModalHeader}
        footer={warrantyModalFooter}
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm"
        onHide={handleCloseWarrantyModal}
      >
        <div className="custom_modal_body">
          <div className="p-1 pt-2 p-sm-4 pt-sm-2 pb-sm-2 w-100">
            <div className="row">
              {/* Purchase date */}
              <div className="col-12">
                <DatePicker
                  id="purchaseDate"
                  label="Purchase date"
                  labelHtmlFor="purchaseDate"
                  required={true}
                  value={purchaseDate}
                  maxDate={today}
                  placeholder="dd/mm/yyyy"
                  onChange={setPurchaseDate}
                  error={purchaseDateError}
                  showClear
                  onClear={() => setPurchaseDate(null)}
                />
              </div>

              {/* Months */}
              <div className="col-12">
                <NumberInput
                  inputId="months"
                  label="Months"
                  labelHtmlFor="months"
                  placeholder="Months"
                  onChange={handleWarrantyMonthChange}
                  value={months}
                  required={true}
                  min={0}
                  error={monthError}
                  formGroupClassName="mb-1"
                />
              </div>
            </div>
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Site modal */}
      <Dialog
        visible={showSiteModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseSiteModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"siteSearchKey"}
                id="siteSearchKey"
                value={siteSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setSiteSearchKey(e.target.value)
                }
                className="custom_form_input data_search_input"
                placeholder="Search site by job number/address"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {siteSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setSiteSearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseSiteModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body">
            {filteredSitesData && filteredSitesData?.length > 0 ? (
              <React.Fragment>
                <div className="data_select_option_area">
                  {filteredSitesData?.map((site) => (
                    <div
                      key={site?.project_id}
                      className={`data_select_option p-ripple ${site?.project_id === selectedSiteData?.project_id ? "selected" : ""}`}
                      onClick={() => handleSelectSite(site)}
                    >
                      {site?.job_number + " - " + site?.address}
                      <Ripple
                        pt={{
                          root: {
                            style: { background: "rgba(164, 96, 253, 0.2)" },
                          },
                        }}
                      />
                    </div>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <div className="no_records_found no_footer">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Storage modal */}
      <Dialog
        visible={showStorageModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseStorageModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"storageSearchKey"}
                id="storageSearchKey"
                value={storageSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setStorageSearchKey(e.target.value)
                }
                className="custom_form_input data_search_input"
                placeholder="Search storage by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {storageSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setStorageSearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseStorageModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_custom_input">
            {filteredStoragesData && filteredStoragesData?.length > 0 ? (
              <React.Fragment>
                <div className="data_select_option_area">
                  {filteredStoragesData?.map((storage) => (
                    <div
                      key={storage?.id}
                      className={`data_select_option p-ripple ${storage?.id === selectedStorageData?.id ? "selected" : ""}`}
                      onClick={() => handleSelectStorage(storage)}
                    >
                      {storage?.storage_name}
                      <Ripple
                        pt={{
                          root: {
                            style: { background: "rgba(164, 96, 253, 0.2)" },
                          },
                        }}
                      />
                    </div>
                  ))}
                </div>
              </React.Fragment>
            ) : (
              <div className="no_records_found">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>

          <div className="page_form_group data_select_modal_footer mb-0">
            <div className="input_with_button_area">
              <InputText
                id="customStorageAddress"
                value={customStorageAddress}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setCustomStorageAddress(e.target.value)
                }
                className="custom_form_input has_add_value custom_data_input"
                placeholder="Enter storage address"
                autoComplete="off"
              />
              <button
                className="add_value_btn fill p-ripple"
                onClick={handleCreateCustomStorage}
                disabled={customCreateLoading || customStorageAddress === ""}
              >
                {customCreateLoading ? (
                  <span>Processing</span>
                ) : (
                  <React.Fragment>
                    <i className="bi bi-plus-lg"></i>
                    <span>Add</span>
                  </React.Fragment>
                )}
                <Ripple />
              </button>
            </div>
            {customStorageAddressError && (
              <small className="form_error_msg">
                {customStorageAddressError}
              </small>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Brand modal */}
      <Dialog
        visible={showBrandModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseBrandModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"brandSearchKey"}
                id="brandSearchKey"
                value={brandSearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setBrandSearchKey(e.target.value)
                }
                className="custom_form_input data_search_input"
                placeholder="Search brand by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {brandSearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setBrandSearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseBrandModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body has_custom_input">
            {filteredBrandsData && filteredBrandsData?.length > 0 ? (
              <div className="data_select_option_area">
                {filteredBrandsData?.map((brand) => (
                  <div
                    key={brand?.id}
                    className={`data_select_option p-ripple ${brand?.id === selectedBrandData?.id ? "selected" : ''}`}
                    style={{ color: brand?.color_code }}
                    onClick={() => handleSelectBrand(brand)}
                  >
                    {brand?.brand_name}
                    <Ripple
                      pt={{
                        root: {
                          style: { background: "rgba(164, 96, 253, 0.2)" },
                        },
                      }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div className="no_records_found">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>

          <div className="page_form_group data_select_modal_footer mb-0">
            <div className="input_with_button_area">
              <InputText
                id="customBrandName"
                value={customBrandName}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setCustomBrandName(e.target.value)
                }
                className="custom_form_input has_add_value custom_data_input"
                placeholder="Enter brand name"
                autoComplete="off"
              />
              <button
                className="add_value_btn fill p-ripple"
                onClick={handleCreateCustomBrand}
                disabled={customCreateLoading || customBrandName === ""}
              >
                {customCreateLoading ? (
                  <span>Processing</span>
                ) : (
                  <React.Fragment>
                    <i className="bi bi-plus-lg"></i>
                    <span>Add</span>
                  </React.Fragment>
                )}
                <Ripple />
              </button>
            </div>
            {customBrandNameError && (
              <small className="form_error_msg">{customBrandNameError}</small>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}

      {/* Category/tool type modal */}
      <Dialog
        visible={showCategoryModal}
        headerClassName="d-none"
        dismissableMask
        className="custom_modal_dialog modal_dialog_sm data_select_modal"
        contentClassName="data_select_modal_content"
        onHide={handleCloseCategoryModal}
      >
        <div className="custom_modal_body data_select_modal_area">
          <div className="data_select_modal_header">
            <div className="data_search_input_area">
              <InputText
                key={"categorySearchKey"}
                id="categorySearchKey"
                value={categorySearchKey}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                  setCategorySearchKey(e.target.value)
                }
                className="custom_form_input data_search_input"
                placeholder="Search category by name"
                autoComplete="off"
                autoFocus
                type={"search"}
              />
              {categorySearchKey === "" ? (
                <i className="bi bi-search"></i>
              ) : (
                <i
                  className="bi bi-x-lg data_search_input_clear"
                  onClick={() => setCategorySearchKey("")}
                ></i>
              )}
            </div>

            <button
              type="button"
              className="data_select_modal_close p-ripple"
              onClick={handleCloseCategoryModal}
            >
              <i className="bi bi-x"></i>
              <Ripple />
            </button>
          </div>

          <div className="data_select_modal_body">
            {filteredToolCategoriesData &&
              filteredToolCategoriesData?.length > 0 ? (
              <React.Fragment>
                <div className="data_select_option_area">
                  {filteredToolCategoriesData?.map((category) => {
                    const isExpanded = expandedCategoryId === category.id;
                    return (
                      <div
                        key={category?.id}
                        className={`data_toggle_option ${isExpanded && "selected"
                          } ${category?.tool_type?.length === 0 && "disabled"}`}
                      >
                        <div
                          className={`data_toggle_header p-ripple ${isExpanded ? "expanded" : ""
                            }`}
                          onClick={() => handleSelectCategory(category)}
                        >
                          <div className="data_toggle_label">
                            <img
                              src={baseURL + category?.path!}
                              alt={category?.category_name}
                            />
                            <span>{category?.category_name}</span>
                          </div>
                          <i className="bi bi-chevron-down"></i>
                          <Ripple
                            pt={{
                              root: {
                                style: {
                                  background: "rgba(164, 96, 253, 0.2)",
                                },
                              },
                            }}
                          />
                        </div>

                        <div
                          className={`data_toggle_body ${isExpanded && "show"}`}
                        >
                          {category?.tool_type &&
                            category?.tool_type?.length > 0 && (
                              <React.Fragment>
                                {category?.tool_type?.map((toolType) => (
                                  <div
                                    key={toolType?.id}
                                    className={`data_toggle_list_data p-ripple ${toolType?.id ===
                                      selectedToolTypeData?.id && "selected"
                                      }`}
                                    onClick={() =>
                                      handleSelectToolType(toolType)
                                    }
                                  >
                                    <img
                                      src={baseURL + toolType?.path}
                                      alt={toolType?.type_name}
                                    />
                                    <span>{toolType?.type_name}</span>
                                    <Ripple
                                      pt={{
                                        root: {
                                          style: {
                                            background:
                                              "rgba(164, 96, 253, 0.2)",
                                          },
                                        },
                                      }}
                                    />
                                  </div>
                                ))}
                              </React.Fragment>
                            )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </React.Fragment>
            ) : (
              <div className="no_records_found no_footer">
                <i className="bi bi-exclamation-circle me-1"></i>
                No data found.
              </div>
            )}
          </div>
        </div>
      </Dialog>
      {/*  */}
    </React.Fragment>
  );
};

export default ToolModal;
